import { createMap, DatalayersMap, IDataLayer, IDatalayerContext, IDataLayerType, isString, LayerTypeId, MapDependencies, models } from "../../omnia"
import { IDatalayersService } from "../../types"
import { parseFieldKey } from "../fields"
import { LayerLoader } from "./layerLoader"

export interface MapContext {

    readonly map: DatalayersMap
    readonly layerContext: IDatalayerContext
    readonly loader: (layerIds: number[]) => PromiseLike<IDataLayer[]>

    getType(typeId: LayerTypeId): IDataLayerType

    viewFieldExtent(fieldId: number): void
    viewFieldExtent(fieldKey: string): void

}

export function useMapContext(svc: IDatalayersService, mapDependencies: MapDependencies, layerLoader: LayerLoader) {

    const [mapContext, setMapContext] = React.useState<MapContext>()

    React.useEffect(() => {

        const map = new DatalayersMap(mapDependencies)

        const typesMap = createMap(svc.getLayerTypes(), t => t.TypeId)

        const layerContext = mapDependencies.createContext(() => [])

        setMapContext({

            map,
            layerContext,
            loader: layerLoader.get,

            getType: (id: LayerTypeId) => typesMap.get(id),

            viewFieldExtent: (key: number | string) => {
                const id = isString(key) ? parseFieldKey(key) : key
                const feature = map.fieldsLayer.findField(id)
                if (feature) {
                    map.viewExtent(feature)
                }
            }

        })

        return () => {
            map.dispose()
        }

    }, [mapDependencies, svc, layerLoader])

    return mapContext

}
